import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useLocation } from 'react-router-dom';

const ETRDetail = ({ i }) => {
	const location = useLocation();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	return (
		<Box
			style={{
				boxShadow: '0 0 10px rgba(0,0,0,.3)',
				backgroundColor: '#FFF',
				marginTop: 20,
				// padding: 10,
			}}>
			<Box
				style={{
					backgroundColor: '#E1E1E1',
					color: 'rgba(0,0,0,.64)',
					padding: 10,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Box
					style={{
						display: 'flex',
						alignItems: 'center',
					}}>
					<img
						src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
						style={{ height: 35 }}
					/>
					<span style={{ fontSize: 14, marginLeft: 10 }}>
						{`${i.Airline_Name} ${i.Airline_Code}-${i.Flight_Number}`}
					</span>
				</Box>
				<span>{`${i.Origin_City} to ${i.Destination_City}`}</span>
			</Box>

			<Box
				style={{
					padding: 20,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Box>
					<Box style={{ display: 'flex', alignItems: 'center' }}>
						<h1>{i.Origin}</h1>
						<span style={{ fontSize: '24px', marginLeft: '12px' }}>
							{i.Departure_DateTime.split(' ')[1]}
						</span>
					</Box>
					<Box>
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Departure_DateTime.split(' ')[0]}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>{i.Origin_City}</span>
					</Box>
				</Box>
				<Box>
					<Box style={{ alignItems: 'center', textAlign: 'center' }}>
						<AccessTimeIcon />
						<h2>2hr 30mn</h2>
					</Box>
				</Box>
				<Box>
					<Box
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}>
						<h1>{i.Destination}</h1>
						<span style={{ fontSize: '24px', marginLeft: '12px' }}>
							{i.Arrival_DateTime.split(' ')[1]}
						</span>
					</Box>
					<Box style={{ textAlign: 'end' }}>
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Arrival_DateTime.split(' ')[0]}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Destination_City}
						</span>
					</Box>
				</Box>
			</Box>
			<Box
				style={{
					backgroundColor: '#E1E1E1',
					color: 'rgba(0,0,0,.64)',
					padding: 10,
					display: 'flex',
					justifyContent: 'space-between',
				}}>
				<Box>
					<span style={{ fontSize: 14 }}>BAGGAGE</span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${i.Origin} to ${i.Destination}`}</span>
				</Box>
				<Box>
					<span style={{ fontSize: 14 }}>CHECK-IN </span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Check_In_Baggage}`}</span>
				</Box>
				<Box>
					<span style={{ fontSize: 14 }}>CABIN</span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Hand_Baggage}`}</span>
				</Box>
			</Box>
		</Box>
	);
};

export default ETRDetail;
